import { render } from "./LActionError.vue?vue&type=template&id=20c39f78"
import script from "./LActionError.vue?vue&type=script&lang=js"
export * from "./LActionError.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__